import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { dmApi } from "./dmApi";
import { thunk } from "redux-thunk";
import globalSlice from "./globalSlice";
import { sliceNames } from "../helpers/constants";
import filterReducer from "./orderApi/filterSlice";
import uploadReducer from "./orderApi/uploadSlice";
import "./vaApi/vaApi";

const rootReducers = combineReducers({
  [sliceNames.GLOBAL]: globalSlice,
  [dmApi.reducerPath]: dmApi.reducer,
  filters: filterReducer, 
  upload: uploadReducer, 
});

const store = configureStore({
  reducer: rootReducers,
  middleware: (getDefaultMiddleware) =>
   getDefaultMiddleware({
      serializableCheck: false,
    }).concat(dmApi.middleware),
    serializableCheck: false, 
});

export default store;
